import { gql } from "@apollo/client";

// What this bucket's limits allow, against what has been consumed.
//
// The one read on these screens that is NOT a delta. Everything on the capture
// path is a net change over a window — the remove handler writes negated
// measures — and datum clamps a capture window to 31 days, which is why "how
// full is this bucket" cannot be answered there at all. A limit's usage is
// aggregated over the limit's own period instead; for the bucket's size limit
// that is the year.
//
// `status` is selected because it is the field that makes the numbers safe to
// render: a null usage means "period not implemented" or "the aggregate
// failed", and drawing either as a 0% bar reads as full headroom. Every
// consumer of this query branches on it before it draws anything.
//
// There is no filter argument, deliberately. A bucket has one set of limits and
// the scope is composed server-side from the resolved bucket row — see the note
// on BucketUsageQueries in the api schema.
export const list = gql`
  query BucketUsageList($bucketId: String!, $input: ListInput) {
    viewer {
      id
      account {
        id
        buckets {
          id
          get(bucketId: $bucketId) {
            id
            usage {
              id
              list(input: $input) {
                id
                last
                truncated
                items {
                  id
                  limitId
                  limitDescription
                  key
                  measure
                  type
                  period
                  threshold
                  limit
                  usage
                  ratio
                  breached
                  status
                  windowStart
                  windowEnd
                }
              }
            }
          }
        }
      }
    }
  }
`;
